var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-row',{attrs:{"justify":"center","no-gutters":""}},[_c('v-col',{attrs:{"cols":_vm.col}},[_c('div',{staticClass:"progressAnimatedHome",style:('height:' +_vm.height+'px'),attrs:{"data-aos":"zoom-in"}})])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }